"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.jobScheduler",
    path: "job-scheduler",
    component: "JobSchedulerConfigurations"
});
let JobSchedulerConfigurations = class JobSchedulerConfigurations extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    openJobSchedulerConfig(...args) {
        const [oid] = args;
        const updateItem = this.updateItem;
        return this.$imodal
            .show({
            name: 'JobSchedulerConfig',
            props: { oid }
        })
            .then(res => {
            console.log(res);
            this.loadData('items');
        });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_job_scheduler_config')
            .then(items => _.orderBy(items, ['created_at', 'id'], ['asc', 'asd']));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3343864469950044_editable;
    b_3343864469950044_columns;
    dataMembers = ['items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_editable', 'b_3343864469950044_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_3343864469950044_editable: false,
                b_3343864469950044_columns: [{
                        name: "suspended",
                        header: this.$fn.pgettext("JobSchedulerConfig", "Suspended"),
                        width: "60px",
                        formatter: "checkbox",
                    },
                    {
                        name: "id",
                        header: this.$fn.pgettext("JobSchedulerConfig", "ID"),
                        width: "180px",
                        formatter: {
                            name: "template",
                            value: "<div>\n\
  <a class=\"text-nowrap\"\n\
     href=\"#\"\n\
     @click=\"globs.openJobSchedulerConfig(row.id)\"\n\
  >\n\
    {{ value }}\n\
  </a>\n\
</div>\n\
",
                        },
                    },
                    {
                        name: "name",
                        header: this.$fn.pgettext("JobSchedulerConfig", "Name"),
                        width: "180px",
                    },
                    {
                        name: "function_name",
                        header: this.$fn.pgettext("JobSchedulerConfig", "Function"),
                        width: "160px",
                    },
                    {
                        name: "trigger",
                        header: this.$fn.pgettext("JobSchedulerConfig", "Trigger"),
                        width: "160px",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_5360_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_6705964765214521_script_5364_getActionArgs_value($event) {
        this.openJobSchedulerConfig();
    }
    async act_6705964765214521_script_5364_getActionArgs($event) {
        return {
            value: () => this.act_6705964765214521_script_5364_getActionArgs_value($event),
        };
    }
    async evh_6705964765214521_clickPreventStop(event, scope) {
        return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8116269939469002_showModal_5366_getActionArgs($event) {
        return {
            name: "FileSelector",
            props: {
                url: this.$fn.urlFor('import_job_scheduler_config'),
                accept: ".yaml",
            },
        };
    }
    async evh_8116269939469002_clickPreventStop(event, scope) {
        return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_5368_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('job_scheduler_config').upsert({ ...$event.data.row }));
    }
    async act_3343864469950044_script_5368_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_5368_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_save(event, scope) {
        return await this.actions.evh_3343864469950044_save.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_5370_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('job_scheduler_config').delete({ ...$event.data.row }));
    }
    async act_3343864469950044_script_5370_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_5370_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_delete(event, scope) {
        return await this.actions.evh_3343864469950044_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5360 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5360_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5359 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5360,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5359],
        });
        const act_8320016629450276_reloadComponentData_5362 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_5361 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_5362,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_5361],
        });
        const act_6705964765214521_script_5364 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6705964765214521_script_5364_getActionArgs,
            events: [],
        });
        const evh_6705964765214521_clickPreventStop_5363 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_script_5364,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_6705964765214521_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_clickPreventStop_5363],
        });
        const act_8116269939469002_showModal_5366 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8116269939469002_showModal_5366_getActionArgs,
            events: [],
        });
        const evh_8116269939469002_clickPreventStop_5365 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_showModal_5366,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8116269939469002_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8116269939469002_clickPreventStop_5365],
        });
        const act_3343864469950044_script_5368 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_5368_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_save_5367 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_5368,
            event: "save",
            displayName: "script",
        });
        const evh_3343864469950044_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_save_5367],
        });
        const act_3343864469950044_script_5370 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_5370_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_delete_5369 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_5370,
            event: "delete",
            displayName: "script",
        });
        const evh_3343864469950044_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_delete_5369],
        });
        return {
            act_7315092382398562_closeModal_5360,
            evh_7315092382398562_close_5359,
            evh_7315092382398562_close,
            act_8320016629450276_reloadComponentData_5362,
            evh_8320016629450276_clickPreventStop_5361,
            evh_8320016629450276_clickPreventStop,
            act_6705964765214521_script_5364,
            evh_6705964765214521_clickPreventStop_5363,
            evh_6705964765214521_clickPreventStop,
            act_8116269939469002_showModal_5366,
            evh_8116269939469002_clickPreventStop_5365,
            evh_8116269939469002_clickPreventStop,
            act_3343864469950044_script_5368,
            evh_3343864469950044_save_5367,
            evh_3343864469950044_save,
            act_3343864469950044_script_5370,
            evh_3343864469950044_delete_5369,
            evh_3343864469950044_delete,
            reload: act_8320016629450276_reloadComponentData_5362,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], JobSchedulerConfigurations.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobSchedulerConfigurations.prototype, "onSize", null);
JobSchedulerConfigurations = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobSchedulerConfigurations);
exports.default = JobSchedulerConfigurations;
vue_property_decorator_1.Vue.component("JobSchedulerConfigurations", JobSchedulerConfigurations);
